import type { PropsWithChildren } from 'react';

import { PostColumnsContext } from './context';

type Props = PropsWithChildren<{
  layout?: string;
  autoColumnWidth?: number;
}>;

export function PostColumnsProvider({ children, layout, autoColumnWidth }: Props) {
  return <PostColumnsContext.Provider value={{ layout, autoColumnWidth }}>{children}</PostColumnsContext.Provider>;
}
